import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const WarehouseBasicInfoComponent = ({ onInnerFormChange, selectedWarehouse, stores }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="WarehouseName"
              name="WarehouseName"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'WarehouseInfo.WarehouseName',
                  selectedWarehouse?.WarehouseInfo
                )
              }}
              type="text"
              value={selectedWarehouse?.WarehouseInfo?.WarehouseName}
          />
      <InputContainer
              label="WarehousePhoneNumber"
              name="WarehousePhoneNumber"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'WarehouseInfo.WarehousePhoneNumber',
                  selectedWarehouse?.WarehouseInfo
                )
              }}
              type="text"
              value={selectedWarehouse?.WarehouseInfo?.WarehousePhoneNumber}
          />
      <InputContainer
            label="Store"
            labelField="StoreInfo.StoreName"
            list={stores}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'WarehouseInfo.StoreId',
                selectedWarehouse?.WarehouseInfo
              );
            }}
            optionName='Choose Store'
            type="select"
            value={selectedWarehouse?.WarehouseInfo?.StoreId}
            valueField="StoreInfo.Id"
        />
     </div>
  }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>
</>
)
export default WarehouseBasicInfoComponent;
